import WorkoutResult from './WorkoutResult';

class WorkoutBenchmarkResult {
  constructor({ _id = null, title = '', results = [] }) {
    this.id = _id;
    this.title = title;
    this.results = results.map((resultData) => new WorkoutResult(resultData));
  }
}

export default WorkoutBenchmarkResult;
